export default __webpack_public_path__ + "static/media/paymentTick.b9d5840e.svg";